/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { AttachLinkIcon16Light } from './AttachLinkIcon16Light';
import { AttachLinkIcon16Regular } from './AttachLinkIcon16Regular';
import { AttachLinkIcon16Solid } from './AttachLinkIcon16Solid';
import { AttachLinkIcon20Light } from './AttachLinkIcon20Light';
import { AttachLinkIcon20Regular } from './AttachLinkIcon20Regular';
import { AttachLinkIcon20Solid } from './AttachLinkIcon20Solid';
import { AttachLinkIcon24Regular } from './AttachLinkIcon24Regular';
import { AttachLinkIcon24Solid } from './AttachLinkIcon24Solid';
import { AttachLinkIcon32Regular } from './AttachLinkIcon32Regular';
import { AttachLinkIcon64Regular } from './AttachLinkIcon64Regular';
var sizes = {
    16: {
        light: AttachLinkIcon16Light,
        regular: AttachLinkIcon16Regular,
        solid: AttachLinkIcon16Solid,
    },
    20: {
        light: AttachLinkIcon20Light,
        regular: AttachLinkIcon20Regular,
        solid: AttachLinkIcon20Solid,
    },
    24: {
        regular: AttachLinkIcon24Regular,
        solid: AttachLinkIcon24Solid,
    },
    32: {
        regular: AttachLinkIcon32Regular,
    },
    64: {
        regular: AttachLinkIcon64Regular,
    },
};
export var AttachLinkIcon = forwardRef('AttachLinkIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
